import { useEffect, useState } from "react";
import ModalV2 from "../ModalV2";
import useModal from "../../hooks/useModal";
import { Button } from "@oc-labs/wt-storybook";

export default function ConfirmModal({}) {
  const [action, setAction] = useState(null);
  const [modalInfo, setModalInfo] = useState({
    title: "Confirm Action",
    description: "Are you sure you want to proceed with this action?"
  });
  const { close, isOpen, modal } = useModal("confirm-modal");
  const props = modal?.props || {};

  useEffect(() => {
    if (isOpen){
      setModalInfo({
        title: props.title || "Confirm Action",
        description: props.description || "Are you sure you want to proceed with this action?"
      });
      setAction(() => props.onConfirm || null);
    } else {
      setModalInfo({
        title: "Confirm Action",
        description: "Are you sure you want to proceed with this action?"
      });
      setAction(null);
    }
  }, [isOpen]);
   
  return (<ModalV2 name="confirm-modal" >
    <div className="w-full max-w-sm bg-white rounded-2xl p-6 text-center">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        {modalInfo.title}
      </h2>
      <p className="text-gray-600 mb-4">
        {modalInfo.description}
      </p>

      <div className="mt-4 flex gap-2">
        <Button
          type="secondary"
          onClick={close}
        >
          Cancel
        </Button>
        
        <Button
          type="danger"
          onClick={() => {
            action && action();
            close();
          }}
        >
          Confirm
        </Button>
      </div>
    </div>
  </ModalV2>)
}